import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* О компании */}
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-icon">🏍️</span>
              <h3>ThaiBike Rent</h3>
              <p className="footer-description">{t.footerDescription}</p>
              <div className="footer-badges">
                <span className="badge">✓ {t.footerVerified}</span>
                <span className="badge">✓ {t.footerInsurance}</span>
                <span className="badge">✓ {t.footerBusinessHours}</span>
              </div>
            </div>
          </div>

          {/* Быстрые ссылки */}
          <div className="footer-section">
            <h4>{t.footerQuickLinks}</h4>
            <div className="footer-links">
              <a href="#bikes">{t.navBikes}</a>
              <a href="#booking">{t.navBooking}</a>
              <a href="#locations">{t.navLocations}</a>
              <a href="#contacts">{t.navContact}</a>
              <a href="/terms">{t.footerTerms}</a>
              <a href="/privacy">{t.footerPrivacy}</a>
              <a href="/cancellation">{t.footerCancellation}</a>
            </div>
          </div>

          {/* Контакты */}
          <div className="footer-section">
            <h4>{t.footerContactUs}</h4>
            <div className="footer-contact">
              <p className="contact-item">
                <span className="contact-icon">📍</span>
                <span>{t.footerAddress}</span>
              </p>
              <p className="contact-item">
                <span className="contact-icon">📞</span>
                <a href="tel:+66615539384">+66 61 553 93 84</a>
              </p>
              <p className="contact-item">
                <span className="contact-icon">✉️</span>
                <a href="mailto:info@thaibikerent.com">info@thaibikerent.com</a>
              </p>
              <p className="contact-item">
                <span className="contact-icon">💬</span>
                <a href="https://wa.me/66615539384">{t.contactWhatsApp}</a>
              </p>
              <p className="contact-item">
                <span className="contact-icon">⏰</span>
                <span>{t.contact24h}</span>
              </p>
            </div>
            
            <div className="footer-social">
              <p>{t.footerFollow}</p>
              <div className="social-icons">
                <a href="https://facebook.com/thaibikerent" aria-label="Facebook" className="social-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="https://instagram.com/thaibikerent" aria-label="Instagram" className="social-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://t.me/thaibikerent" aria-label="Telegram" className="social-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.69 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 0 0-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.4-1.08.39-.36-.01-1.04-.2-1.55-.37-.63-.2-1.13-.31-1.08-.66.02-.14.2-.28.54-.43 2.14-.89 3.57-1.48 4.29-1.77 2.47-1.04 2.98-1.23 3.32-1.24.73-.02 1.18.14 1.43.27.41.22.46.51.42.8z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Информация о компании для Google Ads */}
        <div className="footer-compliance">
          <div className="compliance-info">
            <p>{t.footerLicense} | {t.footerVat}</p>
            <p>{t.footerRequiredDocs}</p>
          </div>
        </div>

        {/* Нижняя часть футера */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>© 2026 ThaiBike Rent Co., Ltd. {t.footerAllRights}</p>
              <div className="legal-links">
                <a href="/terms">{t.footerTerms}</a> | 
                <a href="/privacy">{t.footerPrivacy}</a> | 
                <a href="/cancellation">{t.footerCancellation}</a>
              </div>
            </div>
            <div className="safety-notice">
              <p>⚠️ {t.footerSafety}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;